import { Button } from '../Button';
import { Col } from '../Col';
import { appConfig } from '../config';
import { Div } from '../HTMLElement';
import { t } from '../i18n/i18n';
import { Link } from '../router/Link';
import { Row } from '../Row';
import { PasswordInput, TextInput } from './fields/Input';
import { FormGroup } from './FormGroup';
import { LoginFormHelper, LoginFormProps } from './LoginForm';

export const LoginFormB = (props: LoginFormProps) => (
  <LoginFormHelper {...props}>
    {({ closeModal, fieldsHelper, forgotPasswordPagePath }) => (
      <>
        <Div marginBottom={4}>
          <Row>
            <Col size={6}>
              <FormGroup {...fieldsHelper.username.formGroup} noMarginBottom>
                <TextInput {...fieldsHelper.username.textInput} placeholder={appConfig.form?.showPlaceholder ? t('form.loginForm.fields.username.placeholder') : undefined} />
              </FormGroup>
            </Col>
            <Col size={6}>
              <FormGroup {...fieldsHelper.password.formGroup} noMarginBottom>
                <PasswordInput {...fieldsHelper.password.passwordInput} placeholder={appConfig.form?.showPlaceholder ? t('form.loginForm.fields.password.placeholder') : undefined} />
              </FormGroup>
            </Col>
          </Row>
        </Div>

        {fieldsHelper.buttons.cancel ? (
          <Row>
            <Col size={6}>
              <Div display="grid">
                <Button {...fieldsHelper.buttons.cancel} variant="outline-primary" />
              </Div>
            </Col>
            <Col size={6}>
              <Div display="grid">
                <Button {...fieldsHelper.buttons.submit} />
              </Div>
            </Col>
          </Row>
        ) : (
          <Div display="grid">
            <Button {...fieldsHelper.buttons.submit} />
          </Div>
        )}
        <Div marginTop={3}>
          <small className="text-secondary fw-light">
            <Link className="text-muted" onClick={closeModal} to={forgotPasswordPagePath}>
              {t('account.passwordForgotten')}
            </Link>
          </small>
        </Div>
      </>
    )}
  </LoginFormHelper>
);
